module.exports = __webpack_public_path__ + "img/GlamAngel.df024e2e.jpg";